import { createContext, useReducer } from 'react';

const initialState = {
    paymentType: null,
    paymentStatus: null,
    paymentStatusDesc: null,
    paymentGatewayDetails: null
}
// Create a context for payment
export const PaymentContext = createContext();

export function updatePaymentReducer(state, action) {
    console.log('updatePaymentReducer', state, action);
    switch (action.type) {
        case 'update':
            return {
                ...state,
                ...action.payload
            };
        case 'reset':
            return initialState;
        default:
            return state;
    }
}

export function PaymentProvider({ children }) {
    const [state, dispatch] = useReducer(updatePaymentReducer, initialState);

    return (
        <PaymentContext.Provider value={{ state, dispatch }}>
            {children}
        </PaymentContext.Provider>
    );
}